/** 高仁学堂 — 工业视觉专项培训安排 + 多方向课程库 */

export function formatCoursePrice(price) {
  if (price == null || price === '') return ''
  const num = Number(price)
  if (!Number.isFinite(num) || num <= 0) return '免费'
  return `¥${num.toLocaleString('zh-CN')}`
}

/** ========== 工业视觉专项培训安排 ========== */
const visionMeta = {
  title: '工业视觉系统故障排查与维护专项培训',
  specialTitle: '工业视觉检测与维护专项培训安排表（10天）',
  duration: '10天（2026年8月23日 — 11月1日，周末授课）',
  scheduleText: '8月23日、30日；9月6日、13日、20日、27日；10月11日、18日、25日；11月1日',
  location: '天津市东丽区华明街道华丰路6号低碳产业基地G1',
  mode: '理论讲解 + 分组实操（理论占比30%，实操占比70%，故障排查阶段实操占比80%）',
  teacher: '王立志',
  teacherPhone: '13682135267',
  academicAffairs: '由培训组织方统一安排',
  provider: '天津高仁科技有限公司（实训）',
  audience:
    '工业自动化设备维护人员、视觉检测技术员、自动化相关专业人员（具备基础电气控制常识，有PLC基础者优先）',
  focus: '工业视觉系统故障排查与维护，培养项目开发、调试、维护与排故全流程能力',
  equipment: '工业视觉自动化应用平台（包含西门子PLC-1200和海康）',
  goal: '培养学员独立完成机器视觉项目开发、调试、维护与故障排查的全流程能力',
  note: '本培训共10天，分五个阶段递进：硬件基础→通讯对接→软件编程→协作案例→故障排查与考核。',
  status: 'open',
  learners: 326,
  price: 10000,
  priceUnit: '人',
  enrollLabel: '立即报名',
  scheduleFile: '/brochure/vision-training-schedule-10day.docx',
  scheduleFileName: '工业视觉检测与维护专项培训安排表（10天）.docx',
  tags: ['机器视觉', '工业相机', 'PLC联调', '故障排查', '海康'],
  panelHint: '共 10 天 · 理论约 30% / 实操约 70% · 排故阶段实操约 80%',
  stagesHint: '硬件基础 → 通讯对接 → 软件编程 → 协作案例 → 故障排查与考核',
}

const visionPurposes = [
  '掌握机器视觉系统硬件构成、选型逻辑与多型号设备的调试方法；',
  '熟练完成视觉系统与电脑、PLC的通讯对接，实现产线联动；',
  '掌握主流视觉软件的操作与编程逻辑，能独立开发单零件检测程序；',
  '具备产线常见故障的快速排查与修复能力，降低产线停机风险；',
  '建立标准化的机器视觉项目开发流程与编程规范思维；',
  '掌握视觉系统与工业机器人协作实操应用案例的开发。',
]

const visionNotices = [
  '培训需提供原厂配套的技术文档、操作手册、常见问题排查手册，便于学员课后复习；',
  '培训结束后提供1-3个月的线上答疑支持，解决学员实际应用中遇到的问题；',
  '优先采用产线真实零件作为实操案例，模拟产线真实检测场景，提升实战适配性；',
  '建立专属培训技术交流群，原厂讲师实时答疑；',
  '后续公司新增视觉设备，可优先安排复训补充学习；',
  '培训全程拒绝纯理论灌输，所有知识点均配套对应产线真实案例，保证学员学完即可落地使用；',
  '所有培训形成的标准化文档、故障手册、程序模板，培训结束后统一归档至公司设备技术库。',
]

const visionStages = [
  {
    title: '第一阶段（第1天 8月23日）  硬件基础与设备维护',
    desc: '围绕工业相机、镜头、光源、控制器的核心原理与选型逻辑展开，涵盖系统备份恢复、设备存储管理、基础设置与多型号硬件调试对比，让学员从“读懂硬件”到“动手调试”完成第一阶段能力建构。',
  },
  {
    title: '第二阶段（第2天 8月30日）  通讯基础与PLC对接',
    desc: '从硬件接线规范到本体通讯、电脑通讯，再到与PLC、工业机器人的集成通讯，涵盖协议选型、坐标数据传输、PLC触发与结果反馈全流程，并辅以通讯故障排查实操。',
  },
  {
    title: '第三阶段（第3-4天 9月6日-9月13日）  软件操作与基础检测',
    desc: '系统讲解视觉软件界面与基础操作流程，深入实操模板匹配、边缘检测、Blob分析、颜色识别、尺寸测量等核心算法工具，完成单零件检测程序的从零搭建与多场景适配。',
  },
  {
    title: '第四阶段（第5-7天 9月20日-10月11日）  编程思路与协作案例',
    desc: '建立标准化的视觉项目开发流程与编程规范，进阶到多零件检测、多工位联动的编程思路，最终完成视觉引导机器人协作案例的现场开发与调试。',
  },
  {
    title: '第五阶段（第8-10天 10月18日-11月1日）  故障排查与综合考核',
    desc: '系统梳理硬件、软件、通讯三大类故障排查方法，通过模拟产线故障场景进行实战训练，最终以综合项目实操考核+理论问答形式检验培训成果。',
  },
]

const visionCourses = [
  {
    day: 1,
    date: '8月23日',
    dateLabel: '8月23日',
    weekday: '周日',
    stage: '硬件基础',
    category: '硬件基础与设备维护',
    title: '硬件基础与设备维护',
    practiceRatio: '70%',
    content:
      '工业视觉系统概述；工业相机/镜头/光源/控制器原理与选型；系统备份与恢复；设备存储管理与基础设置；多型号相机参数配置；镜头与光源调试。',
    topics: [
      '工业视觉系统概述、培训目标与课程安排说明',
      '工业相机核心原理与选型逻辑（不同分辨率/接口/品牌对比）',
      '工业镜头原理与选型（焦距、光圈、接口类型与适配场景）',
      '光源类型选型（环形/条形/同轴等）与打光基础',
      '控制器核心原理与功能介绍',
      '系统备份与恢复操作（程序备份下载/上传/兼容性验证）',
      '设备存储管理（内存占用分析、冗余清理、参数文件分类）',
      '设备基础设置（IP地址配置、权限管理、网络参数优化）',
      '多型号相机基础参数配置（曝光、增益、白平衡、帧率、触发模式）',
      '镜头调试（对焦、光圈调节、畸变校正）与光源调试（亮度、打光角度优化）',
    ],
    views: 1260,
    comments: 18,
    likes: 96,
    free: false,
    includes: ['文档', '图文'],
    tags: ['硬件', '工业相机', '光源'],
  },
  {
    day: 2,
    date: '8月30日',
    dateLabel: '8月30日',
    weekday: '周日',
    stage: '通讯对接',
    category: '通讯基础与PLC对接',
    title: '通讯基础与PLC对接',
    practiceRatio: '70%',
    content:
      '硬件接线规范；本体/电脑通讯配置；Profinet、TCP/IP、Modbus、IO 等协议；视觉坐标传输；PLC 触发与 OK/NG 反馈；通讯故障排查。',
    topics: [
      '硬件接线规范（相机供电线、信号线、光源控制线接线与安全规范）',
      '本体通讯配置（设备与控制器内部通讯、信号传输逻辑）',
      '电脑通讯连接（GigE/USB/Camera Link、IP地址匹配、网络异常排查）',
      '通讯协议选型讲解（Profinet、TCP/IP、Modbus、IO等方式接线与参数配置）',
      '视觉定位坐标数据传输（相机标定、坐标偏移转换、信号触发程序编程）',
      'PLC触发控制（PLC信号触发视觉系统拍照检测时序逻辑配置）',
      '拍照结果反馈对接（OK/NG结果、坐标数据反馈PLC、产线分拣/剔除联动设置）',
      '通讯故障排查（通讯断线、数据错位、信号丢失检测与参数修正优化）',
    ],
    views: 980,
    comments: 12,
    likes: 74,
    free: false,
    includes: ['文档', '视频'],
    tags: ['PLC', '通讯', 'Modbus'],
  },
  {
    day: 3,
    date: '9月6日',
    dateLabel: '9月6日',
    weekday: '周日',
    stage: '软件编程',
    category: '软件操作与基础检测（一）',
    title: '软件操作与基础检测（一）',
    practiceRatio: '70%',
    content:
      '软件界面与基础操作流程；检测需求分析；模板匹配与边缘检测工具实操调试。',
    topics: [
      '软件界面详解（工程管理、相机配置、算法工具库、结果输出模块）',
      '基础操作流程（新建工程、相机绑定、参数保存、工程导入导出）',
      '软件基础设置（日志查看、权限管理、检测结果保存与追溯设置）',
      '检测需求分析（外观缺陷、尺寸偏差、定位精度指标拆解）',
      '模板匹配工具实操与参数调试',
      '边缘检测工具实操与参数调试',
    ],
    views: 1540,
    comments: 26,
    likes: 118,
    free: false,
    includes: ['视频', '文档', '链接'],
    tags: ['软件', '模板匹配', '边缘检测'],
  },
  {
    day: 4,
    date: '9月13日',
    dateLabel: '9月13日',
    weekday: '周日',
    stage: '软件编程',
    category: '软件操作与基础检测（二）',
    title: '软件操作与基础检测（二）',
    practiceRatio: '70%',
    content:
      'Blob分析、颜色识别、尺寸测量；完整检测逻辑搭建；单零件好坏判定程序；多材质多缺陷场景适配。',
    topics: [
      'Blob分析工具实操与参数调试',
      '颜色识别工具实操与参数调试',
      '尺寸测量工具实操与参数调试',
      '检测逻辑搭建（图像采集→预处理→特征提取→结果判定完整流程）',
      '单零件好坏判定完整检测程序搭建',
      '多场景适配（金属/塑料/玻璃材质，划痕/缺料/变形缺陷检测优化）',
    ],
    views: 1120,
    comments: 15,
    likes: 88,
    free: false,
    includes: ['文档', '图文', '链接'],
    tags: ['Blob', '尺寸测量', '缺陷检测'],
  },
  {
    day: 5,
    date: '9月20日',
    dateLabel: '9月20日',
    weekday: '周日',
    stage: '协作案例',
    category: '编程思路与进阶检测（一）',
    title: '编程思路与进阶检测（一）',
    practiceRatio: '70%',
    content:
      '视觉项目通用开发流程与编程规范；复杂零件检测；多模板自适应切换；程序稳定性优化。',
    topics: [
      '视觉项目通用开发流程（需求对接→硬件选型→打光调试→程序搭建→参数优化→产线测试）',
      '编程规范（变量命名、程序模块化设计、参数注释、可维护性优化）',
      '复杂零件检测逻辑设计与程序搭建',
      '多模板自适应切换编程（适配工件来料轻微偏差）',
      '程序稳定性优化（降低环境光线、工件摆放偏差带来的检测漂移）',
    ],
    views: 1680,
    comments: 31,
    likes: 142,
    free: false,
    includes: ['视频', '图文'],
    tags: ['编程规范', '多模板', '稳定性'],
  },
  {
    day: 6,
    date: '9月27日',
    dateLabel: '9月27日',
    weekday: '周日',
    stage: '协作案例',
    category: '编程思路与进阶检测（二）',
    title: '编程思路与进阶检测（二）',
    practiceRatio: '70%',
    content:
      '多零件同时检测；多工位联动；视觉与工业机器人通讯；手眼标定；视觉引导定位调试。',
    topics: [
      '多零件同时检测编程思路与实现',
      '多工位联动检测编程思路与实现',
      '视觉系统与工业机器人通讯设置',
      '相机标定实操（手眼标定流程与参数调试）',
      '视觉引导定位坐标数据传输与现场调试',
    ],
    views: 1430,
    comments: 22,
    likes: 105,
    free: false,
    includes: ['视频', '文档'],
    tags: ['多工位', '手眼标定', '机器人'],
  },
  {
    day: 7,
    date: '10月11日',
    dateLabel: '10月11日',
    weekday: '周日',
    stage: '协作案例',
    category: '视觉与工业机器人协作案例',
    title: '视觉与工业机器人协作案例',
    practiceRatio: '70%',
    content:
      '视觉引导机器人项目开发；完整案例：标定→定位抓取→不良品剔除；多相机同步与多工位联动综合实战。',
    topics: [
      '视觉引导机器人项目开发流程讲解',
      '完整案例实操：相机标定→定位抓取→不良品剔除',
      '多相机同步采集编程实战',
      '多工位联动检测综合编程实战',
      '协作案例现场调试与参数优化',
    ],
    views: 1320,
    comments: 19,
    likes: 97,
    free: false,
    includes: ['视频', '文档', '图文'],
    tags: ['视觉引导', '机器人协作', '综合案例'],
  },
  {
    day: 8,
    date: '10月18日',
    dateLabel: '10月18日',
    weekday: '周日',
    stage: '故障排查',
    category: '故障排查与综合实战（一）',
    title: '故障排查与综合实战（一）',
    practiceRatio: '80%',
    content:
      '硬件/软件/通讯故障排查；OK/NG信号异常定位；模拟故障场景实操训练（一）。',
    topics: [
      '硬件故障排查（相机无法连接、图像异常-模糊/偏色/反光、光源不亮、接线松动）',
      '相机OK/NG信号发送异常问题定位与解决',
      '软件故障排查（程序报错、检测结果不稳定、数据输出异常、软件崩溃处理）',
      '通讯故障排查（PLC信号无响应、数据传输失败、时序不匹配调试）',
      '模拟故障场景实操训练（一）',
    ],
    views: 1090,
    comments: 14,
    likes: 81,
    free: false,
    includes: ['视频', '链接'],
    tags: ['故障排查', '硬件', '通讯'],
  },
  {
    day: 9,
    date: '10月25日',
    dateLabel: '10月25日',
    weekday: '周日',
    stage: '故障排查',
    category: '故障排查与综合实战（二）',
    title: '故障排查与综合实战（二）',
    practiceRatio: '80%',
    content:
      '模拟故障场景训练（二）；产线常见问题综合排查；排查方法论与手册编写；综合故障排查实战考核。',
    topics: [
      '模拟故障场景实操训练（二）',
      '产线常见问题综合排查训练',
      '故障排查方法论总结与标准化流程建立',
      '常见问题排查手册编写指导',
      '综合故障排查实战考核',
    ],
    views: 1760,
    comments: 34,
    likes: 156,
    free: false,
    includes: ['文档', '图文', '音频'],
    tags: ['故障排查', '方法论', '考核'],
  },
  {
    day: 10,
    date: '11月1日',
    dateLabel: '11月1日',
    weekday: '周日',
    stage: '综合考核',
    category: '综合项目考核与答疑',
    title: '综合项目考核与答疑',
    practiceRatio: '80%',
    content:
      '实操考核：缺陷检测、多模板切换、视觉引导机器人、多相机多工位、稳定性优化；理论问答；总结答疑与结业。',
    topics: [
      '实操考核：缺陷工件完整检测程序搭建（同步输出尺寸、缺陷、定位三组数据）',
      '实操考核：多模板自适应切换（适配工件来料轻微偏差）',
      '实操考核：完整视觉引导机器人项目（相机标定→定位抓取→不良品剔除）',
      '实操考核：多相机同步采集、多工位联动检测综合编程',
      '实操考核：程序稳定性优化（降低环境光线、工件摆放偏差影响）',
      '理论考核：硬件原理、通讯协议、编程逻辑核心知识点问答',
      '培训总结、答疑与结业',
    ],
    views: 1890,
    comments: 41,
    likes: 168,
    free: false,
    includes: ['视频', '文档', '图文', '链接'],
    tags: ['结业考核', '综合项目', '答疑'],
  },
]

/** 培训安排（当前开放：工业视觉专项） */
export const trainingSchedules = [
  {
    id: 'vision',
    label: '工业视觉专项安排',
    shortLabel: '视觉专项',
    meta: visionMeta,
    purposes: visionPurposes,
    notices: visionNotices,
    stages: visionStages,
    courses: visionCourses,
  },
]

export function getTrainingSchedule(id) {
  return trainingSchedules.find((s) => s.id === id) || trainingSchedules[0]
}

/** 兼容旧引用：默认指向工业视觉专项安排 */
export const trainingMeta = visionMeta
export const trainingPurposes = visionPurposes
export const trainingNotices = visionNotices
export const trainingStages = visionStages
export const trainingCourses = visionCourses

export const trainingAnnouncements = [
  {
    id: 'ann-open',
    headline: '官宣!',
    lines: ['工业视觉专项十天培训开放报名', '海康视觉 · 西门子 PLC-1200'],
    caption: '官宣！工业视觉检测与维护专项十天培训安排正式发布',
    summary:
      '围绕海康工业视觉与西门子PLC-1200，覆盖硬件调试、通讯联调、软件编程、机器人协作与综合考核。',
    tone: 'blue',
  },
  {
    id: 'ann-mode',
    headline: '模式',
    lines: ['理论讲解 + 分组实操', '理论约30%，实操约70%'],
    caption: '培训模式：理论讲解 + 分组实操，理论约占30%，实操约占70%',
    summary: '周末授课，十天内完成培训与考试/考核。',
    tone: 'teal',
  },
  {
    id: 'ann-place',
    headline: '日程',
    lines: ['8月23、30日；9月6、13、20、27日', '10月11、18、25日；11月1日 · 共十天'],
    caption: '培训时间：8月23日、30日；9月6日、13日、20日、27日；10月11日、18日、25日；11月1日',
    summary: '工业视觉专项周末开班，欢迎企业团报与个人报名。',
    tone: 'navy',
  },
  {
    id: 'ann-device',
    headline: '报价',
    lines: ['视觉专项 ¥10,000 / 人', '企业团报可联系教务确认'],
    caption: '工业视觉专项每人10000元',
    summary: '提交报名后教务老师将尽快联系确认开班与团报事宜。',
    tone: 'sky',
  },
]


export const courseIncludeOptions = ['视频', '音频', '文档', '链接', '图文']
export const learnStatusOptions = ['未学习', '学习中', '已学习']
export const courseSortOptions = [
  { key: 'latest', label: '最新' },
  { key: 'views', label: '点击量' },
  { key: 'comments', label: '评论数' },
  { key: 'likes', label: '点赞数' },
]

/** 高仁学堂课程库（按网站产品线整理的培训方向） */
export const academyCourses = [
  {
    id: 'robot-program',
    shortTitle: '机器人培训',
    title: '工业机器人操作与离线编程实训',
    coverTone: 2,
    learners: 412,
    duration: '5天',
    category: '工业机器人',
    featured: true,
    latest: true,
    free: false,
    price: 9800,
    views: 2180,
    comments: 46,
    likes: 192,
    includes: ['视频', '文档', '图文'],
    tags: ['工业机器人', '示教编程', '离线仿真'],
    summary:
      '面向产线操作与运维岗位，掌握机器人安全规范、坐标系、示教编程、IO 联锁与离线仿真，完成典型搬运/码垛任务。',
    chapters: [
      { title: '机器人安全与坐标系基础', duration: '1天', stage: '理论' },
      { title: '示教器操作与点位编程', duration: '1.5天', stage: '实操' },
      { title: 'IO信号、夹具与外围联锁', duration: '1天', stage: '实操' },
      { title: '离线编程与轨迹优化', duration: '1天', stage: '实操' },
      { title: '综合项目考核', duration: '0.5天', stage: '考核' },
    ],
  },
  {
    id: 'drone-ops',
    shortTitle: '无人机培训',
    title: '工业无人机操控与巡检应用实训',
    coverTone: 1,
    learners: 268,
    duration: '3天',
    category: '无人机',
    featured: true,
    latest: true,
    free: false,
    price: 6800,
    views: 1760,
    comments: 28,
    likes: 141,
    includes: ['视频', '文档'],
    tags: ['无人机', '巡检', '航线规划'],
    summary:
      '围绕高仁无人机定制方向，掌握飞行安全、航线规划、图像采集与巡检任务执行，适合电力巡检、园区安防与教学演示场景。',
    chapters: [
      { title: '无人机结构与飞行安全规范', duration: '0.5天', stage: '理论' },
      { title: '基础操控与起降训练', duration: '1天', stage: '实操' },
      { title: '航线规划与巡检任务', duration: '1天', stage: '实操' },
      { title: '影像判读与综合考核', duration: '0.5天', stage: '考核' },
    ],
  },
  {
    id: 'plc-comm',
    shortTitle: 'PLC培训',
    title: 'PLC与工业通讯基础实训',
    coverTone: 4,
    learners: 287,
    duration: '4天',
    category: '自动化',
    featured: true,
    latest: true,
    free: false,
    price: 7800,
    views: 1950,
    comments: 33,
    likes: 158,
    includes: ['视频', '文档', '链接'],
    tags: ['PLC', 'Modbus', '工业通讯'],
    summary:
      '从 PLC 接线与梯形图入门，到 Modbus TCP / IO 触发，完成与视觉、机器人、产线设备的联调项目。',
    chapters: [
      { title: 'PLC硬件认识与编程环境', duration: '1天', stage: '理论' },
      { title: '梯形图逻辑与调试', duration: '1天', stage: '实操' },
      { title: 'Modbus TCP与以太网通讯', duration: '1天', stage: '实操' },
      { title: '与视觉/机器人联调项目', duration: '1天', stage: '实操' },
    ],
  },
  {
    id: 'agv-ops',
    shortTitle: 'AGV培训',
    title: 'AGV调度系统运维与现场调试',
    coverTone: 3,
    learners: 156,
    duration: '3天',
    category: 'AGV',
    featured: false,
    latest: true,
    free: false,
    price: 8600,
    views: 1420,
    comments: 21,
    likes: 112,
    includes: ['视频', '文档', '图文'],
    tags: ['AGV', '调度', '运维'],
    summary:
      '覆盖 AGV / AMR 地图建模、任务下发、交通管制与常见现场故障处理，对接仓储物流与智能产线场景。',
    chapters: [
      { title: 'AGV系统架构与地图建模', duration: '1天', stage: '理论' },
      { title: '任务调度与交通管制实操', duration: '1天', stage: '实操' },
      { title: '现场运维与故障排查', duration: '1天', stage: '实操' },
    ],
  },
  {
    id: 'vision-10day',
    shortTitle: '机器视觉培训',
    title: '工业视觉系统故障排查与维护专项培训',
    coverTone: 1,
    learners: 326,
    duration: '10天',
    category: '机器视觉',
    featured: true,
    latest: true,
    free: false,
    price: 10000,
    views: 2560,
    comments: 52,
    likes: 210,
    includes: ['视频', '文档', '图文', '链接'],
    tags: ['机器视觉', '工业相机', 'PLC联调', '故障排查'],
    summary:
      '2026年8月23日—11月1日周末授课，共10天。围绕海康工业视觉与西门子PLC-1200，覆盖硬件调试、通讯联调、软件编程、机器人协作与综合考核。培训费用每人10000元。',
    chapters: getTrainingSchedule('vision').courses.map((c) => ({
      title: `${c.dateLabel} ${c.title}`,
      duration: '1天',
      stage: c.stage,
    })),
    scheduleRoute: true,
    scheduleId: 'vision',
  },
  {
    id: 'smart-line',
    shortTitle: '智能产线培训',
    title: '智能制造产线综合实训',
    coverTone: 2,
    learners: 243,
    duration: '7天',
    category: '智能制造',
    featured: true,
    latest: true,
    free: false,
    price: 16800,
    views: 1680,
    comments: 29,
    likes: 134,
    includes: ['视频', '文档', '图文'],
    tags: ['智能制造', '产线', '综合实训'],
    summary:
      '打通上下料、视觉检测、机器人装配与信息追溯，完成智能产线单元联调与全线交付演练。',
    chapters: [
      { title: '产线工艺与节拍分析', duration: '1天', stage: '理论' },
      { title: '单元设备联调', duration: '2天', stage: '实操' },
      { title: '视觉检测与信息追溯', duration: '2天', stage: '实操' },
      { title: '全线联调与交付演练', duration: '2天', stage: '实操' },
    ],
  },
  {
    id: 'sensor-lab',
    shortTitle: '传感器培训',
    title: '工业传感器综合实验与选型',
    coverTone: 3,
    learners: 521,
    duration: '2天',
    category: '传感器',
    featured: false,
    latest: true,
    free: false,
    price: 3800,
    views: 2310,
    comments: 38,
    likes: 188,
    includes: ['文档', '图文'],
    tags: ['传感器', '选型', '实验'],
    summary:
      '光电、接近、编码器等常用传感器原理、接线与产线选型要点，配套实验箱完成综合实验。',
    chapters: [
      { title: '传感器原理与信号类型', duration: '0.5天', stage: '理论' },
      { title: '接线、调试与抗干扰', duration: '1天', stage: '实操' },
      { title: '产线选型案例与考核', duration: '0.5天', stage: '考核' },
    ],
  },
  {
    id: 'welding-robot',
    shortTitle: '焊接机器人培训',
    title: '焊接机器人工作站操作与工艺实训',
    coverTone: 4,
    learners: 134,
    duration: '4天',
    category: '工业机器人',
    featured: false,
    latest: true,
    free: false,
    price: 9600,
    views: 980,
    comments: 16,
    likes: 79,
    includes: ['视频', '文档'],
    tags: ['焊接机器人', '工艺', '工作站'],
    summary:
      '围绕焊接机器人工作站，掌握安全规范、示教轨迹、焊接工艺参数与典型工件实操。',
    chapters: [
      { title: '焊接安全与工作站组成', duration: '0.5天', stage: '理论' },
      { title: '示教轨迹与工艺参数', duration: '1.5天', stage: '实操' },
      { title: '典型工件焊接实训', duration: '1.5天', stage: '实操' },
      { title: '质量检查与考核', duration: '0.5天', stage: '考核' },
    ],
  },
  {
    id: 'quadruped-ops',
    shortTitle: '机器狗培训',
    title: '运维机器狗巡检与现场应用实训',
    coverTone: 1,
    learners: 98,
    duration: '3天',
    category: '运维机器人',
    featured: false,
    latest: true,
    free: false,
    price: 8800,
    views: 860,
    comments: 12,
    likes: 67,
    includes: ['视频', '图文'],
    tags: ['机器狗', '巡检', '运维'],
    summary:
      '面向园区与厂区巡检场景，掌握四足机器狗操控、路径任务配置、异常上报与运维流程。',
    chapters: [
      { title: '机器狗结构与安全操控', duration: '0.5天', stage: '理论' },
      { title: '巡检路径与任务配置', duration: '1.5天', stage: '实操' },
      { title: '异常识别与运维演练', duration: '1天', stage: '实操' },
    ],
  },
  {
    id: 'electrician',
    shortTitle: '电工电子培训',
    title: '电工电子技术综合实训与考核',
    coverTone: 2,
    learners: 376,
    duration: '3天',
    category: '电工电子',
    featured: false,
    latest: true,
    free: false,
    price: 4800,
    views: 1540,
    comments: 24,
    likes: 121,
    includes: ['文档', '图文', '视频'],
    tags: ['电工', '电子', '考核装置'],
    summary:
      '基于高级电工与电工电子综合实验装置，完成电路接线、测量调试与考核演练，夯实自动化基础能力。',
    chapters: [
      { title: '安全用电与电路基础', duration: '0.5天', stage: '理论' },
      { title: '接线测量与故障排查', duration: '1.5天', stage: '实操' },
      { title: '综合考核演练', duration: '1天', stage: '考核' },
    ],
  },
  {
    id: 'humanoid-intro',
    shortTitle: '人型机器人培训',
    title: '人型机器人认知与二次开发入门',
    coverTone: 3,
    learners: 112,
    duration: '3天',
    category: '人型机器人',
    featured: false,
    latest: true,
    free: false,
    price: 12800,
    views: 1240,
    comments: 18,
    likes: 95,
    includes: ['视频', '文档'],
    tags: ['人型机器人', '交互', '二次开发'],
    summary:
      '介绍双足与移动人型机器人结构、视觉/语音交互接口与基础二次开发流程，适合展示、科研与教学场景。',
    chapters: [
      { title: '人型机器人结构与应用场景', duration: '0.5天', stage: '理论' },
      { title: '运动控制与交互演示', duration: '1.5天', stage: '实操' },
      { title: '接口调用与入门开发', duration: '1天', stage: '实操' },
    ],
  },
  {
    id: 'teacher-train',
    shortTitle: '师资培训',
    title: '院校师资智能装备教学能力提升',
    coverTone: 4,
    learners: 94,
    duration: '4天',
    category: '师资培训',
    featured: true,
    latest: false,
    free: false,
    price: 6800,
    views: 720,
    comments: 11,
    likes: 58,
    includes: ['文档', '图文', '链接'],
    tags: ['师资培训', '课程建设', '技能大赛'],
    summary:
      '面向院校教师，围绕机器人、视觉、产线等实训项目设计、课堂组织与技能大赛辅导能力提升。',
    chapters: [
      { title: '课程体系与项目化设计', duration: '1天', stage: '理论' },
      { title: '实训台搭建与教学示范', duration: '1.5天', stage: '实操' },
      { title: '竞赛辅导与成果转化', duration: '1.5天', stage: '实操' },
    ],
  },
]

export const allCourseTags = [
  ...new Set(academyCourses.flatMap((c) => c.tags || [])),
]

export const academyBanners = [
  {
    id: 'b1',
    headline: '高仁学堂',
    lines: ['工业视觉专项十天培训开放报名', '10天 · 理论讲解 + 分组实操 + 结业考核'],
    tone: 'blue',
  },
  {
    id: 'b2',
    headline: '最新课程',
    lines: ['机器人培训 · 无人机培训 · PLC培训 · AGV培训', '机器视觉 · 智能产线 · 更多方向'],
    tone: 'teal',
  },
  {
    id: 'b3',
    headline: '培训安排',
    lines: ['视觉专项 ¥10,000 / 人', '8月23日起周末开班 · 共十天'],
    tone: 'navy',
  },
]

export function getAcademyCourse(id) {
  return academyCourses.find((c) => c.id === id) || null
}

export const latestAcademyCourses = academyCourses.filter((c) => c.latest)
export const featuredAcademyCourses = academyCourses.filter((c) => c.featured)

/** 我的学习示例数据（本地演示） */
export const myLearningDemo = [
  {
    courseId: 'robot-program',
    progress: 40,
    status: 'learning',
    lastStudy: '示教器操作与点位编程',
  },
  {
    courseId: 'plc-comm',
    progress: 75,
    status: 'learning',
    lastStudy: 'Modbus TCP与以太网通讯',
  },
  {
    courseId: 'drone-ops',
    progress: 100,
    status: 'done',
    lastStudy: '已完成全部章节',
  },
]

/** 各课程对应在线考试题库（演示） */
function makeQuestion(id, stem, options, answer, explain, score = 20) {
  return { id, type: 'single', score, stem, options, answer, explain }
}

const courseExamBanks = {
  'robot-program': {
    durationMin: 15,
    description: '覆盖工业机器人安全规范、坐标系、示教编程、IO 联锁与离线仿真要点。',
    questions: [
      makeQuestion('rp1', '工业机器人示教编程前，首先应确认的是？', ['网络带宽', '安全模式与急停有效', '显示器分辨率', '浏览器版本'], 1, '操作前必须确认安全模式、急停与防护联锁有效。'),
      makeQuestion('rp2', '示教器点位编程中，常用的坐标系不包括？', ['关节坐标系', '直角坐标系', '工具坐标系', '社交坐标系'], 3, '工业机器人常用关节、直角、工具/用户坐标系。'),
      makeQuestion('rp3', 'IO 联锁的主要作用是？', ['美化界面', '与夹具、外围设备安全协同', '提高屏幕亮度', '更换网线颜色'], 1, 'IO 联锁用于夹具、安全门等外围信号交互。'),
      makeQuestion('rp4', '离线编程与仿真的核心价值是？', ['减少现场示教风险并优化轨迹', '加快相机帧率', '提高手机续航', '更换镜头品牌'], 0, '离线仿真可提前验证路径，降低现场碰撞风险。'),
      makeQuestion('rp5', '搬运/码垛典型任务考核通常关注？', ['轨迹可达、节拍与安全防护', '壁纸美观度', '微信转发量', '系统主题色'], 0, '综合考核关注可达性、节拍与安全。'),
    ],
  },
  'drone-ops': {
    durationMin: 15,
    description: '覆盖飞行安全、航线规划、巡检采集与影像判读等知识点。',
    questions: [
      makeQuestion('dr1', '无人机巡检起飞前必须完成？', ['仅拍照留念', '安全检查与空域确认', '更换壁纸', '关闭全部传感器'], 1, '起飞前需检查机体、电量、空域与天气。'),
      makeQuestion('dr2', '航线规划的主要目的是？', ['美化飞行轨迹', '按既定路径安全覆盖巡检目标', '提高手机续航', '更换镜头品牌'], 1, '航线用于在安全约束下覆盖巡检点位。'),
      makeQuestion('dr3', '工业巡检中影像采集更强调？', ['美颜滤镜', '稳定、可复现的目标覆盖', '社交分享', '夜视美颜'], 1, '巡检强调稳定覆盖与可复现采集。'),
      makeQuestion('dr4', '遇到禁飞区或低电量告警应？', ['继续强飞', '立即返航或就近安全降落', '关闭遥控器', '忽略告警'], 1, '安全优先，低电量/禁飞应返航或安全降落。'),
      makeQuestion('dr5', '影像判读的目标是？', ['仅统计飞行时长', '识别异常并形成巡检结论', '更换固件皮肤', '测试网速'], 1, '判读用于发现缺陷/异常并输出结论。'),
    ],
  },
  'plc-comm': {
    durationMin: 15,
    description: '覆盖 PLC 基础、梯形图、Modbus TCP 与视觉/机器人联调要点。',
    questions: [
      makeQuestion('pl1', 'PLC 编程调试前应先确认？', ['电源、接线与运行模式', '壁纸主题', '浏览器插件', '社交账号'], 0, '先确认供电、接线与 RUN/STOP 模式。'),
      makeQuestion('pl2', '梯形图中常开触点对应？', ['永远断开', '输入为真时导通', '只能用于定时器', '仅用于摄像头'], 1, '常开触点在条件满足时导通。'),
      makeQuestion('pl3', 'Modbus TCP 常见承载网络是？', ['工业以太网', 'HDMI', 'VGA', '蓝牙音箱'], 0, 'Modbus TCP 基于以太网通信。'),
      makeQuestion('pl4', 'PLC 与视觉反馈 OK/NG 常见接口是？', ['HDMI', '数字 IO / 工业以太网', 'VGA', '微信消息'], 1, '现场多用 IO 或工业通讯交互结果。'),
      makeQuestion('pl5', '联调项目失败时优先排查？', ['信号映射与触发时序', '显示器刷新率', '机柜颜色', '操作系统主题'], 0, '先查 IO/寄存器映射与触发时序。'),
    ],
  },
  'agv-ops': {
    durationMin: 15,
    description: '覆盖 AGV 架构、地图建模、任务调度、交通管制与现场运维。',
    questions: [
      makeQuestion('ag1', 'AGV 地图建模的主要目的是？', ['绘制宣传海报', '建立可导航环境模型', '提高帧率', '更换轮胎品牌'], 1, '地图是导航与调度的基础。'),
      makeQuestion('ag2', '交通管制的核心作用是？', ['加快相机帧率', '避免多车冲突并保障通行效率', '提高显示器刷新率', '减少网线长度'], 1, '交通管制防止冲突并维持节拍。'),
      makeQuestion('ag3', '任务调度通常负责？', ['仅播放音乐', '任务下发、路径分配与执行监控', '更换壁纸', '关闭定位'], 1, '调度负责任务分配与执行监控。'),
      makeQuestion('ag4', '现场常见故障不包括？', ['定位丢失', '路径阻塞', '电量不足', '社交媒体断更'], 3, '运维关注定位、路径、电量等现场问题。'),
      makeQuestion('ag5', '仓储物流场景中 AGV 价值在于？', ['自动搬运与柔性物流', '仅装饰通道', '替代全部 PLC', '取消安全规范'], 0, 'AGV 提升搬运效率与柔性。'),
    ],
  },
  'vision-10day': {
    durationMin: 20,
    description: '覆盖工业相机、光源、通讯联调、视觉工具与故障排查等核心知识点。',
    questions: [
      makeQuestion('vs1', '工业相机相较普通监控摄像头更强调？', ['夜视美颜', '稳定触发与可重复成像', '无线连接距离', '社交媒体分享'], 1, '工业视觉强调触发同步与可重复成像。', 10),
      makeQuestion('vs2', '图像整体偏暗、细节不足时优先调整？', ['曝光或增益', 'PLC 程序长度', '机柜颜色', '操作系统主题'], 0, '亮度主要由曝光、增益、光源决定。', 10),
      makeQuestion('vs3', '硬触发拍照通常依赖？', ['外部 IO 触发信号沿', '鼠标双击', '微信消息', '显示器休眠'], 0, '硬触发由外部信号驱动采集。', 10),
      makeQuestion('vs4', '模板匹配工具常用于？', ['定位目标并输出位姿/位置', '更换网线', '提高音量', '关闭光源'], 0, '模板匹配用于目标定位。', 10),
      makeQuestion('vs5', '视觉与 PLC 联调时常见反馈是？', ['OK/NG 与坐标数据', '仅天气数据', '壁纸主题', '社交点赞'], 0, '结果与坐标通过 IO/通讯反馈。', 10),
      makeQuestion('vs6', '手眼标定的主要目的是？', ['建立相机与机器人坐标关系', '美化界面', '加快网速', '更换夹具颜色'], 0, '手眼标定打通视觉与机器人坐标。', 10),
      makeQuestion('vs7', 'Blob 分析常用于？', ['斑点/区域特征提取与判定', '播放音乐', '编辑文档', '绘制海报'], 0, 'Blob 用于连通域特征分析。', 10),
      makeQuestion('vs8', '通讯异常时优先检查？', ['网线、IP、协议与寄存器映射', '机柜喷漆', '壁纸', '键盘灯效'], 0, '先查物理链路与协议配置。', 10),
      makeQuestion('vs9', '工程参数备份的主要目的是？', ['便于版本追溯与现场快速恢复', '加快相机帧率', '提高显示器刷新率', '减少网线长度'], 0, '备份支持恢复与版本管理。', 10),
      makeQuestion('vs10', '结业考核通常包含？', ['理论笔试与实操考核', '仅口头聊天', '仅拍照留念', '仅填写地址'], 0, '结业含理论与实操验收。', 10),
    ],
  },
  'smart-line': {
    durationMin: 15,
    description: '覆盖产线节拍、单元联调、视觉检测与信息追溯等综合知识点。',
    questions: [
      makeQuestion('sl1', '产线节拍分析的目的是？', ['匹配工艺时间与产能目标', '更换墙纸', '提高音量', '关闭追溯'], 0, '节拍决定产能与瓶颈。'),
      makeQuestion('sl2', '单元设备联调重点是？', ['上下料、加工、检测等单元协同', '仅美化 HMI', '取消安全门', '关闭急停'], 0, '单元联调强调设备协同。'),
      makeQuestion('sl3', '信息追溯通常需要关联？', ['条码/工单与检测结果', '仅天气数据', '社交账号', '屏幕壁纸'], 0, '追溯关联工单、条码与结果。'),
      makeQuestion('sl4', '全线联调关注？', ['物流、信号、质量与异常处理闭环', '仅单一设备空转', '关闭视觉', '取消工单'], 0, '全线联调验证整线闭环。'),
      makeQuestion('sl5', '交付演练的价值是？', ['模拟真实生产验收流程', '仅拍照留念', '更换机柜颜色', '测试网速'], 0, '交付演练验证可交付性。'),
    ],
  },
  'sensor-lab': {
    durationMin: 12,
    description: '覆盖光电、接近、编码器等传感器原理、接线与选型。',
    questions: [
      makeQuestion('se1', '接近开关主要用于检测？', ['金属/目标接近状态', '温度色温', '网速', '音量'], 0, '接近开关检测物体接近。'),
      makeQuestion('se2', '光电传感器常见应用是？', ['有无检测、计数与定位辅助', '播放视频', '编辑 Word', '绘制海报'], 0, '光电常用于有无与计数。'),
      makeQuestion('se3', '编码器常输出？', ['位置/速度相关脉冲或数据', '壁纸图片', '天气图标', '社交动态'], 0, '编码器反馈位置或速度。'),
      makeQuestion('se4', '现场抗干扰措施不包括？', ['屏蔽与合理接地', '远离强干扰源', '规范布线', '随意并联市电火线到信号线'], 3, '信号线不可乱接强电。'),
      makeQuestion('se5', '产线选型应优先考虑？', ['检测对象、距离、环境与接口', '仅外观颜色', '品牌口号', '包装样式'], 0, '选型看对象、距离、环境与接口。'),
    ],
  },
  'welding-robot': {
    durationMin: 15,
    description: '覆盖焊接安全、示教轨迹、工艺参数与质量检查要点。',
    questions: [
      makeQuestion('wr1', '焊接机器人作业前必须确认？', ['防护、通风与急停有效', '壁纸主题', '网速', '键盘灯效'], 0, '焊接安全与急停优先。'),
      makeQuestion('wr2', '示教轨迹质量直接影响？', ['焊缝连续性与可达性', '显示器分辨率', '手机续航', '社交点赞'], 0, '轨迹决定焊缝路径质量。'),
      makeQuestion('wr3', '焊接工艺参数通常包括？', ['电流、电压、速度等', '壁纸亮度', '浏览器字体', '机柜颜色'], 0, '工艺参数决定熔深与成型。'),
      makeQuestion('wr4', '典型工件实训目标是？', ['按工艺完成合格焊缝', '仅空运行不焊接', '关闭送丝', '取消防护'], 0, '实训要完成合格焊接。'),
      makeQuestion('wr5', '质量检查关注？', ['外观成型、缺陷与尺寸', '宣传文案', '主题色', '网线长度'], 0, '质检看成型与缺陷。'),
    ],
  },
  'quadruped-ops': {
    durationMin: 12,
    description: '覆盖机器狗安全操控、巡检路径配置与异常运维。',
    questions: [
      makeQuestion('qd1', '机器狗现场操控首先注意？', ['人员距离与地形安全', '壁纸美观', '社交分享', '关闭定位'], 0, '先确保人机与地形安全。'),
      makeQuestion('qd2', '巡检路径配置的目的是？', ['覆盖关键点并稳定执行', '仅随机游荡', '提高音量', '更换外壳颜色'], 0, '路径用于覆盖关键巡检点。'),
      makeQuestion('qd3', '异常上报通常包括？', ['位置、时间与异常类型', '仅表情包', '壁纸截图', '天气玩笑'], 0, '异常需可追溯信息。'),
      makeQuestion('qd4', '电量不足时应？', ['返航充电或就近安全停止', '继续强行任务', '关闭通信', '忽略告警'], 0, '低电量应安全回收。'),
      makeQuestion('qd5', '运维演练重点是？', ['异常处置与任务恢复流程', '仅拍照', '更换贴纸', '测试网速'], 0, '演练异常处置与恢复。'),
    ],
  },
  electrician: {
    durationMin: 12,
    description: '覆盖安全用电、电路接线测量与故障排查考核要点。',
    questions: [
      makeQuestion('el1', '电工实训前必须做到？', ['断电确认与安全防护', '带电随意触摸', '取消接地', '忽略警告牌'], 0, '先断电确认与防护。'),
      makeQuestion('el2', '万用表测量前应？', ['选择正确档位与量程', '随便拧档', '短路表笔测试', '关闭所有保险'], 0, '档位量程选择正确才能测。'),
      makeQuestion('el3', '常见故障排查顺序是？', ['先安全，再外观/供电，后逐级定位', '先拆主板', '先换全部元件', '先上网搜索表情包'], 0, '安全优先，再系统定位。'),
      makeQuestion('el4', '接地的主要作用是？', ['人身与设备安全防护', '提高网速', '美化机柜', '增加音量'], 0, '接地保障安全。'),
      makeQuestion('el5', '综合考核关注？', ['接线正确、测量规范与排故思路', '字迹漂亮', '拍照角度', '服装颜色'], 0, '考核规范操作与排故。'),
    ],
  },
  'humanoid-intro': {
    durationMin: 12,
    description: '覆盖人型机器人结构、运动交互与二次开发入门。',
    questions: [
      makeQuestion('hu1', '人型机器人应用常见于？', ['展示、科研与教学交互', '仅替代全部产线 PLC', '取消安全规范', '替代电网'], 0, '当前多用于展示与教研。'),
      makeQuestion('hu2', '运动控制演示关注？', ['平衡、步态/关节动作稳定性', '壁纸切换', '网速测试', '键盘灯效'], 0, '关注运动稳定与安全。'),
      makeQuestion('hu3', '视觉/语音交互接口用于？', ['感知指令并反馈执行', '仅播放广告', '关闭传感器', '更换外壳'], 0, '交互接口实现感知与反馈。'),
      makeQuestion('hu4', '二次开发入门通常从？', ['官方 SDK/接口调用示例', '直接改内核电源', '拆卸电池短路', '删除系统'], 0, '从官方接口与示例入手。'),
      makeQuestion('hu5', '现场演示安全要求是？', ['划定区域并有急停措施', '人群紧贴机器人', '关闭急停', '随意推搡'], 0, '演示必须安全隔离与急停。'),
    ],
  },
  'teacher-train': {
    durationMin: 12,
    description: '覆盖智能装备教学组织、实训指导与课程转化要点。',
    questions: [
      makeQuestion('tt1', '师资培训的核心目标是？', ['提升智能装备教学与指导能力', '仅参观拍照', '取消实训', '缩短安全培训'], 0, '目标是教学能力提升。'),
      makeQuestion('tt2', '实训教学设计应包含？', ['目标、步骤、安全与考核点', '仅播放视频', '无讲义', '无答疑'], 0, '完整教学设计含考核点。'),
      makeQuestion('tt3', '设备教学示范时优先？', ['安全规范与标准操作流程', '跳过安全直接通电', '让学生自行拆机', '关闭急停'], 0, '示范先讲安全与标准流程。'),
      makeQuestion('tt4', '竞赛辅导常强调？', ['规范、效率与问题定位能力', '仅速度不管安全', '抄袭方案', '忽略规则'], 0, '竞赛兼顾规范与能力。'),
      makeQuestion('tt5', '成果转化可体现为？', ['教案、任务工单与资源库建设', '仅口头宣传', '删除资料', '关闭课程'], 0, '转化成可复用教学资源。'),
    ],
  },
}

export function getCourseExam(courseId) {
  const course = getAcademyCourse(courseId)
  const bank = courseExamBanks[courseId]
  if (!course || !bank) return null
  const questions = bank.questions
  const totalScore = questions.reduce((sum, q) => sum + q.score, 0)
  return {
    course,
    meta: {
      id: `exam-${courseId}`,
      courseId,
      title: `${course.shortTitle || course.category} · 结业测评`,
      durationMin: bank.durationMin || 15,
      passScore: 60,
      totalScore,
      description: bank.description,
    },
    questions,
  }
}

export function listExamCourses() {
  return academyCourses.filter((c) => courseExamBanks[c.id])
}

/** @deprecated 兼容旧引用：默认指向机器视觉课程考试 */
export const examMeta = getCourseExam('vision-10day')?.meta
export const examQuestions = getCourseExam('vision-10day')?.questions || []

/** 知识资料（演示） */
export const knowledgeItems = [
  {
    id: 'k1',
    title: '工业机器人示教与安全操作指南',
    type: '文档',
    category: '工业机器人',
    size: '2.4 MB',
    updatedAt: '2026-06-12',
  },
  {
    id: 'k2',
    title: '无人机巡检航线规划速查表',
    type: '文档',
    category: '无人机',
    size: '1.1 MB',
    updatedAt: '2026-06-18',
  },
  {
    id: 'k3',
    title: 'PLC 与 Modbus TCP 联调示例说明',
    type: '课件',
    category: '自动化',
    size: '5.6 MB',
    updatedAt: '2026-06-22',
  },
  {
    id: 'k4',
    title: 'AGV 调度与现场运维检查清单',
    type: '清单',
    category: 'AGV',
    size: '0.6 MB',
    updatedAt: '2026-07-01',
  },
  {
    id: 'k5',
    title: '工业相机成像异常与打光对照图集',
    type: '图集',
    category: '机器视觉',
    size: '8.2 MB',
    updatedAt: '2026-07-05',
  },
  {
    id: 'k6',
    title: '培训安全与实操纪律须知',
    type: '须知',
    category: '培训管理',
    size: '0.3 MB',
    updatedAt: '2026-05-20',
  },
]
